// react
import { useState } from 'react';

// router
import { useSearchParams } from 'react-router-dom';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions, DialogActionsProps } from '../DialogActions/DialogActions';

// forms
import { FormUploadDocs } from '../../forms/FormUploadDocs/FormUploadDocs';

// props
export interface DialogUploadDocsContractProps {
	DialogActionsProps?: Partial<DialogActionsProps>;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogUploadDocsContract = ({
	DialogActionsProps = {},
	isOpen,
	onClose,
	onSuccess,
}: DialogUploadDocsContractProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);
	const [searchParams] = useSearchParams();

	// vars
	const paramDialogContract = searchParams.get('dialogContract');

	DialogActionsProps.actions = [
		{
			children: t('cancel'),
			onClick: onClose,
		},
		{
			children: t('uploadDocuments'),
			form: 'form-upload-docs-contract',
			loading: isLoading,
			type: 'submit',
			variant: 'contained',
		},
	];
	DialogActionsProps.title = {
		children: t('uploadDocuments'),
		variant: 'h3',
	};
	DialogActionsProps.IconCircleProps = { type: 'document' };
	DialogActionsProps.alignItems = 'center';

	return (
		<DialogActions hasClose={true} isOpen={isOpen} onClose={onClose} {...DialogActionsProps}>
			<FormUploadDocs
				contractId={paramDialogContract ? Number(paramDialogContract) : undefined}
				onClose={onClose}
				onSuccess={onSuccess}
				setIsLoading={setIsLoading}
			/>
		</DialogActions>
	);
};
